module.exports = __webpack_public_path__ + "img/img2.c7b7f2a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/04/img2.png
// module id = 234
// module chunks = 0